import React from "react";
import { Skeleton } from "antd";
import { ThemeProvider as StyledThemeProvider, DefaultTheme } from "styled-components";
import {
  RankingGridCard,
  RankingGridHeader,
  RankingGridRow,
  RankingGridHeaderText,
  RankingGridItemWrapper,
  RankingGridItemImage,
  RankingGridText,
} from "./styles";
import { ItemsRankingGridProps } from "./constants";
import { useTheme } from "../../../context/ThemeContext";
import { addCommasInPrices } from "./constants";
import { getMediaURL } from "../../../context/API";

const ItemsRankingGrid: React.FC<ItemsRankingGridProps> = ({ data, isLoading = false }) => {
  const { isDarkMode } = useTheme();

  const themeMode: "light" | "dark" = isDarkMode ? "dark" : "light";
  const styledTheme = { mode: themeMode } as DefaultTheme;

  return (
    <StyledThemeProvider theme={styledTheme}>
      <RankingGridCard>
        <RankingGridHeader>
          <RankingGridHeaderText>Item</RankingGridHeaderText>
          <RankingGridHeaderText style={{ textAlign: "right" }}>
            Units Sold
          </RankingGridHeaderText>
          <RankingGridHeaderText style={{ textAlign: "right" }}>
            Revenue ($)
          </RankingGridHeaderText>
        </RankingGridHeader>
        <div>
          {isLoading ? (
            Array.from({ length: 5 }).map((_, index) => (
              <RankingGridRow key={index}>
                <RankingGridItemWrapper>
                  <Skeleton.Avatar active size={40} />
                  <Skeleton active paragraph={{ rows: 1, width: 100 }} />
                </RankingGridItemWrapper>
                <Skeleton active paragraph={{ rows: 1, width: 60 }} />
                <Skeleton active paragraph={{ rows: 1, width: 80 }} />
              </RankingGridRow>
            ))
          ) : (
            data.slice(0, 5).map((item) => (
              <RankingGridRow key={item.id}>
                <RankingGridItemWrapper>
                  <RankingGridItemImage
                    src={getMediaURL(item.imageUrl)}
                    alt={item.item}
                    onError={(e) => {
                      (e.target as HTMLImageElement).src = "https://via.placeholder.com/40";
                    }}
                  />
                  <RankingGridText>{item.item}</RankingGridText>
                </RankingGridItemWrapper>
                <RankingGridText style={{ textAlign: "right" }}>
                  {item.totalTimesSold}
                </RankingGridText>
                <RankingGridText style={{ textAlign: "right" }}>
                  ${addCommasInPrices((parseFloat(String(item.totalRevenue)) || 0).toFixed(2))}
                </RankingGridText>
              </RankingGridRow>
            ))
          )}
        </div>
      </RankingGridCard>
    </StyledThemeProvider>
  );
};

export default ItemsRankingGrid;
